import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import footerLink from '../assets/footerLink.png';

function Footer() {

    const currentYear = () => {
        return new Date().getFullYear();
    };

    return <div>
        <div className={styles.footer}>

            <div>
                <div><Link to={"a-propos-de-nous"} >À propos de nous</Link></div>
                <div><Link to={"/organisateurs"} >Pour les organisateurs</Link></div>
                <div><Link to={"/ville-quebec/aujourdhui"} reloadDocument>Aujourd'hui à Québec</Link></div>
                <div><Link to={"/ville-quebec/evenements-cette-semaine"} reloadDocument>Cette semaine à Québec</Link></div>
                <div><Link to={"/ville-quebec/activites-gratuites"} reloadDocument>Activités gratuites à Québec</Link></div>
                <div><Link to={"/ville-quebec/activites-familiales"} reloadDocument>Activités familiales à Québec</Link></div>
                <div><Link to={"presse"}>Presse</Link></div>
                <div><Link to={"politique-de-confidentialite"}>Politique de confidentialité</Link></div>
            </div>
            <div>
                <Link to={"/"}><img className={styles.footerLink} width="300" height="87" decoding="async" alt="Vivez votre ville à 100%" src={footerLink} /></Link>
            </div>
            <div>
                <a href="https://www.facebook.com/alentours.ca" target="_blank" rel="noopener"><img className={styles.socialIcon} width="50" height="50" decoding="async" alt="facebook" src={facebook}/></a>
                <a href="https://www.instagram.com/alentours.ca" target="_blank" rel="noopener"><img className={styles.socialIcon} width="50" height="50" decoding="async" alt="instagram" src={instagram}/></a>
            </div>
            
        </div>
        © alentours {currentYear()}. Tous droits réservés
    </div> 
}

export default Footer;